import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { RequestManagementService, } from '../services/request-management.service';
import { UserService } from '../services/user.service';
import 'rxjs/add/operator/map';
import { TermModel } from '../_models/_index';

@Injectable()
export class TermOfUseService {

    constructor(private requestManagement: RequestManagementService,
        private userService: UserService) { }

    public getTerms(serviceTypeID:number): Promise<TermModel> {
        return this.requestManagement.callGetRequest('terms-of-use/get', {
             "serviceTypeID": serviceTypeID
        }).map((response: Response) => {
            return <TermModel>response.json();
        }).toPromise();
    }



    public editTerm(model: TermModel): Promise<TermModel> {
        model.updatorID = this.userService.getCurrentUser().id;
        return this.requestManagement.callPostRequest('terms-of-use/edit', model).map((response: Response) => {
            return <TermModel>response.json();
        }).toPromise();
    }

  

}



// WEBPACK FOOTER //
// ./src/app/services/term-of-use.service.ts